import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Navbar from '../components/header/navbar'
import { serviceData } from '../components/service/serviceData'
import ServiceDetailedCard from '../components/service/ServiceDetailedCard'
import AOS from 'aos'

const ServicePage = () => {
  const { slug } = useParams()
  // console.log('serviceData:', serviceData)
  const service = serviceData.find((s) => s.slug === slug)
  // console.log('service:', service)
  const data = service.service

  useEffect(() => {
    AOS.init({ once: false })
  }, [])

  return (
    <div className='max-w-7xl mx-auto'>
      <Navbar />
      <div className='flex flex-col justify-center items-center md:px-20 mt-10'>
        <div className='w-full flex items-center flex-wrap pt-0 px-4 sm:pb-10 md:pb-12'>
          <div className='w-full md:w-1/2 pt-8 sm:pt-0 order-1 sm:order-0'>
            <div className='sm:pl-4 lg:pl-10'>
              <img
                className='w-full sm:w-5/6 h-full mx-auto object-cover'
                src={service.image}
                data-aos='slide-right'
                data-aos-duration='1500'
                alt=''
              />
            </div>
          </div>

          <div className='w-full md:w-1/2 order-0 sm:order-1'>
            <div className='text-center md:text-left'>
              <h1
                className='text-3xl sm:text-4xl md:text-5xl lg:leading-normal tracking-tight font-extrabold text-gray-900'
                data-aos='flip-up'
                data-aos-duration='1000'
              >
                {service.heroHead}
              </h1>

              <p
                className='mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0'
                // data-aos="slide-up"
                // data-aos-duration="1000"
              >
                {service.heroPara}
              </p>
            </div>
          </div>
        </div>
        {/* range of services for a particular service */}
        <div className='w-full sm:w-1/2 md:w-2/3 pb-10'>
          <div className='w-full grid sm:md:grid-cols-2 md:grid-cols-2 gap-6'>
            {data.map((serviceDetail) => {
              return (
                <ServiceDetailedCard data={serviceDetail} key={data.title} />
              )
            })}
          </div>
        </div>
        <div className=''></div>
        <div className='flex flex-col justify-center px-4 py-8 lg:p-10 hidden'>
          <h1 className='font-semibold text-3xl sm:text-4xl md:text-5xl pb-4'>
            {service.head2}
          </h1>
          <span className=' font-medium leading-loose pb-8'>
            <p>{service.para1}</p> <br />
            <p>{service.para2}</p> <br />
            <p>{service.para3}</p> <br />
            <p>{service.para4}</p> <br />
            <p>{service.para5}</p> <br />
            <p>{service.para6}</p> <br />
          </span>
        </div>
      </div>
    </div>
  )
}

export default ServicePage
